import {
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel,
} from '@microsoft/signalr'

class SignalRHub {
  client: HubConnection
  status: HubConnectionState
  constructor() {
    this.client = new HubConnectionBuilder()
      .withUrl(this.getConnectionString())
      .configureLogging(LogLevel.Debug)
      .withAutomaticReconnect([0, 1000, 5000, 10000])
      .build()
    this.status = HubConnectionState.Disconnected
  }

  getConnectionString(): string {
    return window.env.APP_HUB.replace('hub', 'notifications') || 'http://localhost:5007/tickmill'
  }

  getStatus(): HubConnectionState {
    return this.client.state
  }

  setStatus(newStatus: HubConnectionState): void {
    this.status = newStatus
  }
}

export default SignalRHub
